export const FlowKeywords = {
    // Properties of each block
    data: 'data',
    error: 'error',
    metadata: 'metadata',
    config: 'config',
    state: 'state',
    startTime: 'startTime',
    endTime: 'endTime',
    duration: 'duration',
    // Global for a flow's input parameters
    inputs: 'inputs',
    // Globals within an iterator or repeat block
    element: 'element',
    lastResult: 'lastResult',
    index: 'index',
};
// Properties of each block
export const flowBlockFieldNames = [
    FlowKeywords.data,
    FlowKeywords.error,
    FlowKeywords.metadata,
    FlowKeywords.startTime,
    FlowKeywords.endTime,
    FlowKeywords.duration,
    FlowKeywords.config,
    FlowKeywords.state,
];
export const reservedFlowBlockNames = [
    FlowKeywords.inputs,
    FlowKeywords.element,
    FlowKeywords.lastResult,
    FlowKeywords.index,
];
//# sourceMappingURL=keywords.js.map